import React, { Component, Fragment } from 'react';
import beautify from 'js-beautify';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperItem, FormWrapperInputComponent,
} from "../../../common/component/Index";
import DEFINE, { HOTEL, PATHS, UPLOAD_DIRECTORY, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../constants/Define";
import { isEqual, get, cloneDeep, find } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import EmailTemplate from '../../../../../models/EmailTemplate';
import Wrapper from './../../../common/component/Wrapper';
import CodeEditor from './../../../common/component/CodeEditor';
import TextArea from './../../../common/component/TextArea';

import './EmailTemplateDetail.less';
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import RichTextEditor, { ClassicEditor } from "../../../common/component/RichTextEditor";
import { message, Select } from "antd";
import i18n from "../../../../../constants/initLng";
import Switch from "../../../common/component/Switch";
import UploadImage from "../../../common/component/UploadImage";
import TranslateButton from '../../../common/component/TranslateButton';
import Span from '../../../common/component/Span';
import EmailEditor from '../../../common/component/EmailEditor/EmailEditor';

let permisionActions = [];
const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
};

export default class EmailTemplateDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            emailTemplate: this.props.emailTemplateState.detail.emailTemplate,
        };
    }

    componentDidMount() {
        this.initDetail()
    }

    initDetail() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            // const emailTemplate = find(emailTemplateState.emailTemplates, h => h.id === id);
            // if(page) this.setState({page});
            this.props.getEmailTemplateDetail(id);
        }
    }

    componentWillUnmount() {
        this.props.setEmailTemplateDetail(new EmailTemplate())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.emailTemplateState.detail.emailTemplate && !isEqual(nextProps.emailTemplateState.detail.emailTemplate, this.props.emailTemplateState.detail.emailTemplate)) {
            this.setState({
                emailTemplate: nextProps.emailTemplateState.detail.emailTemplate,
                action: nextProps.emailTemplateState.detail.emailTemplate.id ? DETAIL_ACTIONS.UPDATE : this.state.action
            });
        }
    }

    render() {
        const { t, emailTemplateState } = this.props;
        const { isFetchingDetail } = emailTemplateState;
        const { action, validation, emailTemplate } = this.state;
        return (
            <LoadingComponent spinning={isFetchingDetail}>
                <PageListComponent className="email-template-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'emailTemplate'}
                        titleHeader={action === "CREATE"
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.emailTemplate.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.emailTemplate.title')}`.toLowerCase()))
                        }
                        componentRight={null
                            // FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            // <TranslateButton
                            //     languages={emailTemplate.translations}
                            //     current={emailTemplate.languageCode}
                            //     validation={validation.languageCode}
                            //     onChange={this.onShowTranslate}
                            //     onClear={this.onExitTranslate}
                            //     defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                            //     onSelectDefault={language => this.onChange('languageCode', language.code)}
                            //     onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={false}
                        action={action}
                        isGetItem={false}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        submitButtonRight={true}
                    >
                        <Wrapper className='col-md-12 m-0 p-0 detail-section'>
                            <FormWrapperItem>
                                <Wrapper className="col-md-12">
                                    <FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={emailTemplate.title}
                                        validation={validation.title}
                                        labelTitle={t(`item.emailTemplate.titleEmail`)}
                                    >
                                        <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`title`}
                                            onChange={(e) => this.onChange('title', e.target.value)}
                                            value={checkUndefine(emailTemplate.title)} />
                                    </FormWrapperInputComponent>
                                    <FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={emailTemplate.content}
                                        validation={validation.content}
                                        labelTitle={t(`item.emailTemplate.content`)}
                                    >
                                        <EmailEditor title={emailTemplate.title} name="content" height={'500px'}
                                            onChange={value => this.onChange('content', value)}
                                            value={checkUndefine(emailTemplate.content)} />
                                    </FormWrapperInputComponent>
                                    <Wrapper className="col-md-12 row m-0 p-0">
                                        <FormWrapperInputComponent
                                            className="col-md-8 m-0 p-0"
                                            labelTitle={t(`item.emailTemplate.note`)}
                                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                        >
                                            <TextArea
                                                className="form-control" name="note" height={'400px'}
                                                onChange={e => this.onChange('note', e.target.value)}
                                                value={checkUndefine(emailTemplate.note)} />
                                        </FormWrapperInputComponent>
                                        <FormWrapperInputComponent
                                            className="col-md-4 m-0 p-0 pl-4"
                                            labelTitle={t(`item.emailTemplate.status`)}
                                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                        >
                                            <br />
                                            <Switch checked={emailTemplate.isActive}
                                                onChange={(value, e) => this.onChange('isActive', value)}
                                                name={`isActive`} />
                                            <Span className="ml-2">{emailTemplate.isActive ? t(`item.emailTemplate.isActived`) : t(`item.emailTemplate.isUnactived`)}</Span>
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                </Wrapper>
                            </FormWrapperItem>
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    onChange = (fieldName, value) => {
        const emailTemplate = this.state.emailTemplate;
        if (Array.isArray(value)) {
            emailTemplate[fieldName] = value
        } else if (fieldName === 'isActive') {
            emailTemplate[fieldName] = value
        } else {
            emailTemplate[fieldName] = value.trimLeft();
        }
        this.setState({ emailTemplate });
    };

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.EMAIL_TEMPLATE.LIST.path);
        }
    }

    onShowTranslate = (language) => {
        const { emailTemplate } = this.state;
        emailTemplate.setTranslate(language.code);
        emailTemplate.setData();
        this.setState({ emailTemplate, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const emailTemplate = cloneDeep(this.state.emailTemplate);
        const action = DETAIL_ACTIONS[emailTemplate.id ? 'UPDATE' : 'CREATE'];
        emailTemplate.setTranslate(undefined, true);
        emailTemplate.setData();
        this.setState({ emailTemplate, action });
    }

    onSaveTranslate = () => {
        const { emailTemplate } = this.state;
        const translateFunction = emailTemplate.translate.id ? this.props.updateEmailTemplateTranslate : this.props.createEmailTemplateTranslate;
        translateFunction(emailTemplate, emailTemplate.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { emailTemplate } = this.state;
        emailTemplate.setTranslate(language.code);
        this.props.deleteEmailTemplateTranslate(emailTemplate, { id: emailTemplate.id });
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { emailTemplate, action } = this.state;
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createEmailTemplate(emailTemplate)
            } else {
                this.props.updateEmailTemplate(emailTemplate)
            }
        } else {
            message.error(i18n.t('validation.checkForm'))
        }
    };

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                title: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.emailTemplate.titleEmail`)),
                content: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.emailTemplate.content`)),
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.emailTemplate, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }
}
